<template>
  <page-view title="提现系统配置">
    <div slot="headerContent">
      <!-- <a-alert type="warning">
        <template #message>
          <div style="font-size: 14px; color: rgba(0, 0, 0, 0.65)">
            {{ description }}
          </div>
        </template>
      </a-alert> -->
	<a-alert
	  message=""
	  description="专业提供个人微信间自动转账解决方案，关联后重启机器人生效"
	  type="warning"
	/>
      <div class="link" v-if="hideLc">
        <a target="_blank" href="http://p.liangcangnc.net.cn/">
          <span>粮仓用户端</span>
        </a>
        <a target="_blank" href="http://e.liangcangnc.net.cn/">
          <span>粮仓商户端（自建商户后台）</span>
        </a>
        <a
          v-if="hideLcDesc"
          href="javascript:;"
        >
          <a-popover title="提示">
            <template slot="content">
              <p style="color:#999;fontSize:14px">请联系客服解答</p>
            </template>
              <span>粮仓系统使用说明</span>
          </a-popover>
        </a>
      </div>
    </div>
    <div slot="extra">
      <div class="extra-img">
        <img v-if="typeof extraImage !== 'undefined'" :src="extraImage" />
      </div>
    </div>
    <div ref="content">
      <a-card :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="查询条件">
                  <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                    <a-select-option value="1">子账号ID</a-select-option>
                    <a-select-option value="2">微信昵称</a-select-option>
                    <a-select-option value="3">API密钥</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="查询内容">
                  <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
                </a-form-item>
              </a-col>
              <template v-if="advanced"></template>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                  <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
          <a-button type="primary" @click="$refs.addModal.show()">新增提现账户</a-button>
        </div>
        <s-table ref="table" size="default" rowKey="id" :columns="columns" :data="loadData" :scroll="{ x: 1200 }">
          <span slot="withdraw_key" slot-scope="text, record">
            <span>*********{{ record.withdraw_key.slice(record.withdraw_key.length - 4) }}</span>
          </span>
          <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

          <span slot="robot_num" slot-scope="text, record">
            <a-tag color="red" @click="$refs.listModal.show(record.id, record)">{{
              record.relation_to_main_sub_list.length
            }}</a-tag>
          </span>
          <span slot="update_time" slot-scope="text, record">
            <span>{{ record.update_time }}</span>
          </span>
          <span slot="create_time" slot-scope="text, record">
            <span>{{ record.create_time }}</span>
          </span>
          <span slot="remark" slot-scope="text, record">
            <span>{{ record.remark ? record.remark : '无' }}</span>
          </span>
          <template slot="action" slot-scope="text, record">
            <a @click="$refs.bindModal.show(record.id, record)">关联机器人</a>
            <a-divider type="vertical" />
            <a @click="$refs.listModal.show(record.id, record)">已关联机器人</a>
            <a-divider type="vertical" />
            <a-popconfirm placement="topLeft" @confirm="handleDelete(record.id, record)">
              <template slot="title">
                <p>您确认要删除吗？</p>
              </template>
              <a>删除</a>
            </a-popconfirm>
          </template>
        </s-table>
      </a-card>
    </div>
    <add-modal ref="addModal" @ok="$refs.table.refresh()"></add-modal>
    <bind-modal ref="bindModal" @ok="$refs.table.refresh()"></bind-modal>
    <list-modal ref="listModal" @ok="$refs.table.refresh()"></list-modal>
  </page-view>
</template>

<script>
import PaymentApi from '@/api/payment'
import moment from 'moment'
import { PageView } from '@/layouts'
import { STable } from '@/components'
import AddModal from './modules/AddModal'
import BindModal from './modules/BindModal'
import ListModal from './modules/ListModal'
export default {
  name: 'PaymentIndex',
  components: {
    PageView,
    STable,
    AddModal,
    BindModal,
    ListModal
  },
  data() {
    return {
      //description: '专业提供个人微信间自动转账解决方案，关联后重启机器人生效',
      extraImage: 'https://gw.alipayobjects.com/zos/rmsportal/RzwpdLnhmvDJToTdfDPe.png',
      dataSource: [],
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: 60
        },
        {
          title: '粮仓API密钥',
          dataIndex: 'withdraw_key',
          scopedSlots: { customRender: 'withdraw_key' }
        },
        {
          title: '备注',
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '关联机器人数量',
          scopedSlots: { customRender: 'robot_num' },
          width: 200
        },
        {
          title: '更新时间',
          scopedSlots: { customRender: 'update_time' },
          width: 220,
          sorter: true
        },
        {
          title: '创建时间',
          scopedSlots: { customRender: 'create_time' },
          width: 220,
          sorter: true
        },
        {
          title: '操作',
          width: '250px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return PaymentApi.getPaymentList(Object.assign(parameter, this.queryParam))
      },
      currentChangeId: null
    }
  },
  filters: {},
  created() {},
  computed: {
    hideLc() {
      return !this.$store.state.brand.extend.includes('HideLc')
    },
    hideLcDesc() {
      return !this.$store.state.brand.extend.includes('HideLcDesc')
    }
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleBind(id) {
      this.currentChangeId = id
      this.$refs.multipleSelectRobotModal.show()
    },
    handleSelectRobot(items) {
      const key_id = this.currentChangeId
      const ids = items.map(item => {
        return item.id
      })
      const loading = this.$message.loading('正在加载')
      PaymentApi.bind({ key_id, ids })
        .then(res => {
          if (res.code === 1) {
            setTimeout(() => {
              this.$message.success('绑定成功')
            }, 100)
            this.$refs.table.refresh()
          } else {
            setTimeout(() => {
              this.$message.error(res.msg)
            }, 100)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },
    handleDelete(id, data) {
      if (!(data.relation_to_main_sub_list.length == 0)) {
        this.$message.error('删除前请将已关联的机器人取消关联')
        return false
      }
      const loading = this.$message.loading('正在移除')
      PaymentApi.delete({ key_list: [id] })
        .then(res => {
          if (res.code === 1) {
            setTimeout(() => {
              this.$message.success('移除成功')
            }, 100)
            this.$refs.table.refresh()
          } else {
            setTimeout(() => {
              this.$message.error(res.msg)
            }, 100)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 24px 24px 0;
  .link {
    margin-top: 16px;
    &:not(:empty) {
      margin-bottom: 16px;
    }
    a {
      margin-right: 32px;
      height: 24px;
      line-height: 24px;
      display: inline-block;
      i {
        font-size: 24px;
        margin-right: 8px;
        vertical-align: middle;
      }
      span {
        height: 24px;
        line-height: 24px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
.page-menu-search {
  text-align: center;
  margin-bottom: 16px;
}
.page-menu-tabs {
  margin-top: 48px;
}

.extra-img {
  margin-top: -60px;
  text-align: center;
  width: 195px;

  img {
    width: 100%;
  }
}

.mobile {
  .extra-img {
    margin-top: 0;
    text-align: center;
    width: 96px;

    img {
      width: 100%;
    }
  }
}

.meta-content {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  height: 80px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>
